<div class="main-console-container" >

  <div class="row">
    <div class="col-md-6">
      <div class="main-console-title">
        <img src="assets/img/RSA_NewLogo_White-RGB.png" class="securid-label" alt="RSA SecurID Logo"/>
      </div>
    </div>

    <div class="col-md-6">
      <div class="main-console-card">

        <form class="h-100" [formGroup]="securidForm" novalidate [style.visibility]="ready ? 'visible' : 'hidden'">
          <div class="mb-2">
            <app-errormsg [errorDiv]="errorDiv" [errorMsg]="errorMsg"></app-errormsg>
            <span>Enter your pin and passcode</span>
            <img src="assets/img/help-icon.svg" title="Use your pin and the passcode from the RSA Authenticator app" alt="SecurID tooltip" class="tooltip-icon"/>
          </div>

          <div>
            <input id="securid-in" type="password" pattern="^[0-9]*" inputmode="numeric" 
                   maxlength="10" formControlName="code" autocomplete="one-time-code" 
                   placeholder="Passcode (PIN + Token)" class="form-control user-input securid"
                   (keypress)="allowOnlyNumbers($event)">
            <div *ngIf="securidForm.controls['code'].invalid && securidForm.controls['code'].dirty" class="alert alert-danger move-up mb-0">
              <div *ngIf="securidForm.controls['code'].errors?.required" class="alert-red">
                Passcode (PIN + Token) is required.
              </div>
              <div *ngIf="securidForm.controls['code'].errors?.pattern" class="alert-red">
                Invalid character. Only numbers are accepted as input.
              </div>
            </div>
          </div>
          <app-remember-device></app-remember-device>
          <div class="row mt-4">
            <div class="col">
              <button id="submit-btn" type="submit" [disabled]="securidForm.controls['code'].invalid" class="primary-btn"
                      (click)="onCodeSubmit()">
                Submit
              </button>
            </div>
            <div class="col ms-auto">
             <button class="secondary-btn" (mousedown)="factorSelect()" *ngIf="factorSelection">
                More Options
              </button>
            </div>
          </div>

          <div>
            <app-userinfo></app-userinfo>
          </div>
        </form>

        <app-loading *ngIf="!ready && !errorDiv"></app-loading>

      </div>
    </div>
  </div>
</div>
